<template>
  <div class="container no-margin">
    <text-input
      :hint="placeholder"
      :scroll-on-focus="scrollOnFocus"
      :label="label"
      :name="name"
      :value="value"
      @input="onInput"
      @click="$emit('click')"
      @focus="$emit('focus')"
      :required="required"
      pattern="[0-9]*"
      inputmode="numeric"
      :maxlength="maxlength"
      :subhint="subhint"
      :validation-error="error"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "CuilNumberInput",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "name",
    "value",
    "maxlength",
    "subhint",
    "scrollOnFocus"
  ],
  data() {
    return {
      checked: false
    };
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El número no es válido";
        }
      }
      return null;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        const numberRegex = /^[0-9-]*$/;
        return numberRegex.test(this.value.trim()) && this.value.length === 13;
      }
      return true;
    }
  }
};
</script>

<style scoped>
div.container {
  margin: 0;
}
</style>
